import { render, staticRenderFns } from "./JsonExcel.vue?vue&type=template&id=baddc2ec"
import script from "./JsonExcel.vue?vue&type=script&lang=js"
export * from "./JsonExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports